/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".link--light[_ngcontent-%COMP%]{color:#000;cursor:pointer;text-decoration:underline}.link--light[_ngcontent-%COMP%]:not(.disabled):not([disabled]):hover{text-decoration:none}input[type=checkbox][_ngcontent-%COMP%]:focus, input[type=file][_ngcontent-%COMP%]:focus, input[type=radio][_ngcontent-%COMP%]:focus{outline:-webkit-focus-ring-color auto 5px!important;outline-offset:-2px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/css/documents.component.less.shim.ngstyle.js.pre-build-optimizer.js